<template>
  <section class="content">
    <div class="warning-block">
      <span class="text-red">＊</span>
      營運報表模組已搬至「
      <a @click="goto" class="cursor-pointer">數據分析 > 趨勢分析</a>
      」，請至新後台管理系統操作、檢視相關內容，此區域(舊後台)功能即將關閉。
    </div>
    <div class="row">
      <div class="col-12">
        <div class="box">
          <div class="box-body">
            <div class="z-index-1">
              <!-- 品牌 -->
              <div class="inline-block from-group pull-left " v-if="brandBrief.length > 1" style="width: auto; min-width: 150px;">
                <multiselect
                  v-model="brandSelect"
                  :options="brandBrief"
                  label="label"
                  :allow-empty="false"
                  :close-on-select="true"
                  placeholder="品牌"
                  :show-labels="false"
                  :preselect-first="true"
                  @input="changeBrand"
                >
                </multiselect>
              </div>
              <!-- 門市 -->
              <div class="from-group pull-left m-l-5 flex" v-if="storeBrief.length > 1">
                <div style="width: auto; min-width: 150px;">
                  <multiselect
                    v-model="storeSelect"
                    :options="storeBrief"
                    label="label"
                    :allow-empty="false"
                    :close-on-select="true"
                    placeholder="門市"
                    :show-labels="false"
                    :preselect-first="true"
                    @input="changeStore"
                  >
                  </multiselect>
                </div>
                <div v-if="storeSelect.value" class="ein">
                  統編：{{ein}}<br>抬頭：{{storeName}}
                </div>
              </div>
              <div v-if="storeBrief.length === 0 && getRoleType === 10" class="ein">
                統編：{{ein}}<br>抬頭：{{storeName}}
              </div>
            </div>
            <div class="clear"></div>
            <div class="p-t-50">
              <div class="row">
                <div class="col-xs-12">
                  <!-- Tab -->
                  <ul class="nav nav-tabs" style="margin-bottom: 10px;">
                    <li role="presentation" :class="{active: isType('daily')}">
                      <a @click.prevent="selectTab = 'daily'">每日訂單
                      </a>
                    </li>
                    <li role="presentation" :class="{active: isType('monthly')}">
                      <a @click.prevent="selectTab = 'monthly'">每月訂單
                      </a>
                    </li>
                  </ul>
                  <!-- Button -->
                  <div v-if="selectTab === 'daily'" class="download-block m-r-20">
                    <div class="btn btn-default btn-table-title"
                      :disabled="isDownloading"
                      @click="exportFile('chart')">
                      <i class="fa fa-download"></i>
                      匯出圖表
                      <Clip class="cliploading" :loading="isDownloading" :color="'#528BB8'" :size="'16px'"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 時間區間 -->
            <div class="row m-t-25 m-l-15">
              <div class="col-xs-12 col-md-6">
                <div class="flex align-center">
                  <div class="text-14 m-r-15 m-l-15">資料期間</div>
                  <div class="flex align-center" v-if="selectTab === 'monthly'">
                    <date-picker 
                      v-model="monthlySearch.start_date" 
                      type="month" 
                      valueType="format" 
                      :clearable="false" 
                      :disabled-date="startMonthLimit" 
                      class="w-120"
                    />
                    <div class="m-l-5 m-r-5">-</div>
                    <date-picker 
                      v-model="monthlySearch.end_date" 
                      type="month" 
                      valueType="format" 
                      :clearable="false" 
                      :disabled-date="endMonthLimit" 
                      class="w-120" 
                      input-class="mx-input input-group-input"
                    />
                  </div>
                  <div class="flex align-center" v-else>
                    <date-picker 
                      v-model="dailySearch.start_date" 
                      type="date" 
                      valueType="format" 
                      :clearable="false" 
                      :disabled-date="startDateLimit" 
                      class="w-120"
                    />
                    <div class="m-l-5 m-r-5">-</div>
                    <date-picker 
                      v-model="dailySearch.end_date" 
                      type="date" 
                      valueType="format" 
                      :clearable="false" 
                      :disabled-date="endDateLimit" 
                      class="w-120" 
                      input-class="mx-input input-group-input"
                    />
                  </div>
                  <button 
                    class="btn btn-default submit-btn input-group-button" 
                    type="button" 
                    @click="searchOrderSummary()"
                  >
                    <i class="fa fa-search"></i>
                  </button>
                </div>
              </div>
              <!-- 日期快捷鍵 -->
              <div class="col-xs-12 col-md-6 text-right">
                <div class="m-r-20" v-if="selectTab === 'monthly'">
                  <button class="btn btn-xs btn-primary p-x-10" @click="setDate('year')">近一年</button>
                </div>
                <div class="m-r-20" v-else>
                  <button class="btn btn-xs btn-primary p-x-10 m-r-5" @click="setDate('week')">近一週</button>
                  <button class="btn btn-xs btn-primary p-x-10" @click="setDate('month')">近一個月</button>
                </div>
              </div>
            </div>
            <div class="canvas-block">
              <!-- 月份下拉 -->
              <div class="download-block z-index-1 p-r-5" v-if="selectTab === 'daily'">
                <select v-model="month" @change="changeMonth" class="form-control">
                  <option v-for="item in monthlyOptions" :key="item.value" :value="item.value" :disabled="item.disable">{{item.name}}</option>
                </select>
              </div>
              <!-- 折線圖 -->
              <div class="m-b-15">訂單數量</div>
              <canvas id="amount-chart"></canvas>
              <div class="m-t-64 m-b-15">訂單金額</div>
              <canvas id="money-chart"></canvas>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="box">
          <div class="box-body canvas-block m-t-10">
            <div class="z-index-1">
              <div class="m-t-25">訂單列表</div>
              <!-- 時間區間 -->
              <div class="row m-t-25 m-b-15">
                <!-- 下載報表 -->
                <div class="col-xs-12 col-md-6">
                  <div class="flex align-center">
                    <div class="text-14 m-r-15">資料期間</div>
                    <div class="flex align-center">
                      <date-picker 
                        v-model="tableSearch.start_date" 
                        type="date" valueType="format" 
                        :clearable="false" 
                        :disabled-date="startDateLimit" 
                        class="w-120"
                      />
                      <div class="m-l-5 m-r-5">-</div>
                      <date-picker 
                        v-model="tableSearch.end_date" 
                        type="date" 
                        valueType="format" 
                        :clearable="false" 
                        :disabled-date="tableEndDateLimit" 
                        class="w-120"
                        input-class="mx-input input-group-input"
                      />
                    </div>
                    <button 
                      class="btn btn-default submit-btn input-group-button" 
                      type="button" 
                      @click="paginate.tableIndex = 1, searchTable()"
                    >
                      <i class="fa fa-search"></i>
                    </button>
                  </div>
                </div>
                <div class="col-xs-12 col-md-6 text-right">
                  <div class="btn btn-default btn-table-title"
                    @click="exportFile('table')" :disabled="isDownloading">
                    <i class="fa fa-download"></i>
                    下載報表
                    <Clip class="cliploading" :loading="isDownloading" :color="'#528BB8'" :size="'16px'"/>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 table-responsive p-x-0 m-t-10">
                <table aria-describedby="example1_info" role="grid" id="example1" class="table table-hover table-bordered table-striped dataTable">
                  <thead>
                  <tr role="row">
                    <th aria-controls="example1">日期</th>
                    <th aria-controls="example1">已接單訂單總數</th>
                    <th aria-controls="example1">外送訂單數</th>
                    <th aria-controls="example1">自取訂單數</th>
                    <th aria-controls="example1">內用-桌邊掃碼訂單數</th>
                    <th aria-controls="example1">已接單訂單總金額</th>
                    <th aria-controls="example1">
                      退訂訂單總數
                      <span data-toggle="tooltip" data-placement="bottom" title="退訂(店家退訂，系統退訂，已取消)訂單總數">
                        <i class="fa fa-question-circle" aria-hidden="true"></i>
                      </span>
                    </th>
                    <th aria-controls="example1">
                      退訂訂單總金額
                      <span data-toggle="tooltip" data-placement="bottom" title="退訂(店家退訂，系統退訂，已取消)訂單總金額">
                        <i class="fa fa-question-circle" aria-hidden="true"></i>
                      </span>
                    </th>
                    <!-- col different-->
                  </tr>
                  </thead>
                  <tbody>
                    <tr class="even" role="row" v-for="(item, key, index) in tableData" :key="index">
                      <td>{{item.date | date}}</td>
                      <td>{{item.order_amount_accepted}}</td>
                      <td>{{item.order_amount_delivery}}</td>
                      <td>{{item.order_amount_takeout}}</td>
                      <td>{{item.order_amount_qrcode_dinein || 0}}</td>
                      <td><b>${{item.order_money_accepted}}</b></td>
                      <td>{{item.order_amount_rejected}}</td>
                      <td><b>${{item.order_money_rejected}}</b></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <paginate :pageAmount="pageAmount" :total="paginate.total" :isActive="isActive"
                :groupAmount="paginate.groupAmount" :clickPage="clickPage"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// components
import Chart from 'chart.js'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
// datepicker & monthpicker
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import Clip from 'vue-spinner/src/ClipLoader.vue'
import { setSharedToken } from '../../../assets/js/shared-token.js'

// vuex
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'OperatingChart',
  components: {
    Multiselect,
    DatePicker,
    'Clip': Clip
  },
  data () {
    return {
      roleType: 0,
      selectTab: 'daily',
      isChangeBrand: false, // 是否為品牌更新
      // 品牌 & 門市
      brandBrief: [],
      storeBrief: [],
      brandSelect: {label: '== 品牌 ==', value: 0},
      storeSelect: {label: '== 門市 ==', value: 0},
      // 日期搜尋
      dailySearch: {
        start_date: null,
        end_date: null,
        data: {}
      },
      // 月份下拉值
      month: 0,
      // 月份下拉清單
      monthlyOptions: [],
      // 月份搜尋
      monthlySearch: {
        start_date: null,
        end_date: null,
        data: {}
      },
      // 列表搜尋
      tableSearch: {
        start_date: null,
        end_date: null
      },
      // 圖表資訊
      chartData: {
        labels: [],
        amount: [],
        money: []
      },
      tableData: {}, // 列表資料
      tableMeta: {},
      paginate: {
        count: 10,
        total: 0,
        tableIndex: 1,
        groupAmount: 10
      },
      amountChart: null, // 訂單數量圖
      moneyChart: null, // 訂單金額圖
      isDownloading: false,
      storesInfo: []
    }
  },
  filters: {
    date: (data) => {
      return moment(data).format('MM/DD')
    }
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    getFile () {
      return this.$parent.getFile
    },
    maxEndMonth () {
      // 最大選擇月份
      // (start + 24 months) or this month
      const lastMonth = moment(this.monthlySearch.start_date).add('23', 'months').format('YYYY-MM')
      return moment().isBefore(lastMonth) ? moment().format('YYYY-MM') : lastMonth
    },
    pageAmount () {
      return Math.ceil(this.paginate.total / this.paginate.count)
    },
    ein () {
      if (this.storeSelect.value) {
        return this.storesInfo.filter(x => x.store_id === this.storeSelect.value)[0].ein
      }
      return ''
    },
    storeName () {
      if (this.storeSelect.value) {
        return this.storesInfo.filter(x => x.store_id === this.storeSelect.value)[0].bl_name
      }
      return ''
    }
  },
  created () {
    this.roleType = parseInt(this.getRoleType, 10)
    this.getBrandBrief()
    this.initDate()
  },
  methods: {
    ...mapActions(['setBrandId', 'setStoreId']),
    isActive (index) {
      if (this.paginate.tableIndex === index) return true
      else return false
    },
    initDate () {
      // 日期：預設近 15 天
      this.dailySearch.start_date = moment().subtract(15, 'days').format('YYYY-MM-DD')
      this.dailySearch.end_date = moment().subtract(1, 'days').format('YYYY-MM-DD')
      // 月份：預設近 6 個月
      this.monthlySearch.start_date = moment().subtract(6, 'months').format('YYYY-MM')
      this.monthlySearch.end_date = moment().format('YYYY-MM')
      // 列表：預設近 20 天
      this.tableSearch.start_date = moment().subtract(20, 'days').format('YYYY-MM-DD')
      this.tableSearch.end_date = moment().subtract(1, 'days').format('YYYY-MM-DD')
    },
    maxEndDate (type) {
      // 最大選擇日期
      // (start + 365 or 180 days) or yesterday
      const startDate = type === 'chart' ? 'dailySearch' : 'tableSearch'
      const yesterDay = moment().subtract(1, 'days').format('YYYY-MM-DD')
      const lastDay = moment(this[startDate].start_date).add(type === 'chart' ? '365' : '180', 'days').format('YYYY-MM-DD')
      return moment(yesterDay).isBefore(lastDay) ? yesterDay : lastDay
    },
    // 變更時間
    setDate (type) {
      switch (type) {
        case 'year':
          this.monthlySearch.start_date = moment().subtract(12, 'months').format('YYYY-MM')
          this.monthlySearch.end_date = moment().format('YYYY-MM')
          break
        case 'month':
          this.dailySearch.start_date = moment().subtract(30, 'days').format('YYYY-MM-DD')
          this.dailySearch.end_date = moment().subtract(1, 'days').format('YYYY-MM-DD')
          break
        case 'week':
          this.dailySearch.start_date = moment().subtract(7, 'days').format('YYYY-MM-DD')
          this.dailySearch.end_date = moment().subtract(1, 'days').format('YYYY-MM-DD')
          break
      }
      this.searchOrderSummary()
    },
    changeBrand (input) {
      this.storeBrief = []
      this.storeSelect = []
      this.paginate.tableIndex = 1
      const brandId = input.value
      if (input.value !== 99 && input.value !== 0) {
        this.getStoreBrief(brandId)
      }
      if (typeof input.value !== 'undefined') {
        this.isChangeBrand = true
        this.dailySearch.data = []
        this.monthlySearch.data = []
        this.searchOrderSummary()
        this.searchTable()
      }
    },
    changeStore (input) {
      // 防止更新品牌時，更新門市再多打一次 API
      this.paginate.tableIndex = 1
      if (typeof input.value !== 'undefined' && !this.isChangeBrand) {
        this.dailySearch.data = []
        this.monthlySearch.data = []
        this.searchOrderSummary()
        this.searchTable()
      }
      this.isChangeBrand = false
    },
    changeMonth () {
      this.showOrderChart(this.dailySearch.data[this.month])
    },
    getBrandBrief () {
      this.brandBrief = []
      const url = '/brand/listBrief?is_delete=0&list_sort=name ASC'
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          const bList = response.data.list
          // 品牌數大於 0 (Admin 或 Brand 權限)
          if (bList.length > 1) {
            if ([99, 30].includes(this.roleType)) {
              const defaultBrand = {label: '== 品牌 ==', value: 0}
              this.brandBrief.push(defaultBrand)
              this.brandSelect = defaultBrand
              for (let i = 0; i < bList.length; i++) {
                let obj = {label: bList[i].name, value: bList[i].brand_id}
                this.brandBrief.push(obj)
              }
              this.searchOrderSummary()
              this.searchTable()
            }
          } else if (bList.length === 1) {
            // 品牌數 = 1 (Brand 或 Store 權限)
            if ([10, 30].includes(this.roleType)) {
              const val = bList[0].brand_id
              this.getStoreBrief(val, true)
              this.setBrandId(val)
            }
          }
        }
      })
    },
    getStoreBrief (brandId, first = false) {
      this.storeBrief = []
      const url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC'
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          const sList = response.data.list
          if (sList.length > 1) {
            this.storeBrief.push({label: '== 所有門市 ==', value: 0})
            for (let i = 0; i < sList.length; i++) {
              let obj = {label: sList[i].name, value: sList[i].store_id}
              this.storeBrief.push(obj)
            }
          }
          if (this.roleType !== 99 && first) {
            this.searchOrderSummary()
            this.searchTable()
          }
          if (this.roleType === 10) {
            this.setStoreId(this.storeSelect.value)
          }
          this.storesInfo = sList
        }
      })
    },
    // 設定每日訂單 月份下拉選項
    setMonthSelectOptions (start, end) {
      this.monthlyOptions = []
      let startMonth = start + '/01'
      let endMonth = end + '/01'
      let year = 0

      while (moment(startMonth).isSameOrBefore(endMonth)) {
        if (year && (year !== moment(startMonth).year())) {
          // 加入年分文字
          this.monthlyOptions.push({
            value: null,
            name: `--${moment(startMonth).year()}--`,
            disable: true
          })
        }
        this.monthlyOptions.push({
          value: `${moment(startMonth).format('YYYY-MM')}`,
          name: `${moment(startMonth).month() + 1} 月`,
          disable: false
        })
        year = moment(startMonth).year()
        startMonth = moment(startMonth).add(1, 'months')
      }
      this.month = this.monthlyOptions[0].value || 0
    },
    // 設定搜尋參數
    setQuery (type, changeTable = false) {
      const name = changeTable ? 'tableMeta' : `${type}Search`
      let query = {
        start_date: this[name].start_date.replace(/-/g, ''),
        end_date: this[name].end_date.replace(/-/g, '')
      }
      switch (type) {
        case 'table':
          query.list_type = 'daily'
          break
        case 'daily':
          query.list_type = 'daily_group_by_month'
          break
        case 'monthly':
          query.list_type = 'monthly'
          break
      }
      if (this.brandSelect.value && this.roleType !== 10) query.brand_ids = this.brandSelect.value
      if (this.storeSelect.value) query.store_ids = this.storeSelect.value

      return query
    },
    // 訂單圖表查詢
    searchOrderSummary (switchTab = false) {
      const query = this.setQuery(this.selectTab)
      const searchParams = new URLSearchParams(query)
      const url = '/statistic/orderSummary?' + searchParams.toString()
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          // 設定每日訂單 月份下拉選項
          const start = response.data.meta.start_date
          const end = response.data.meta.end_date
          if (!switchTab && this.selectTab === 'daily' && start && end) {
            this.setMonthSelectOptions(moment(start).format('YYYY/MM'), moment(end).format('YYYY/MM'))
          }

          // 產出圖表
          this[`${this.selectTab}Search`].data = response.data.list
          const list = this.selectTab === 'daily' ? response.data.list[this.month] : response.data.list
          this.showOrderChart(list)
        }
      })
    },
    // 訂單列表查詢
    searchTable (type = null) {
      let query = this.setQuery('table', type === 'changePage')
      const pageObj = {
        return_type: 'page',
        page: this.paginate.tableIndex || 1,
        size: this.paginate.count || 10
      }
      query = {...query, ...pageObj}
      const searchParams = new URLSearchParams(query)
      const url = '/statistic/orderSummary?' + searchParams.toString()
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          this.tableData = response.data.list
          this.tableMeta = response.data.meta
          this.paginate.total = response.data.meta.total
          this.paginate.tableIndex = response.data.meta.page
          this.paginate.count = response.data.meta.size
        }
      })
    },
    // 顯示折線圖
    showOrderChart (list = {}) {
      // 清空圖表資訊
      for (let key in this.chartData) {
        this.chartData[key] = []
      }

      // 圖表日期轉換
      for (const i in list) {
        let date = list[i].date
        if (this.selectTab === 'daily') {
          date = moment(date).format('MM/DD')
        } else {
          date = moment(date).format('YYYY/MM')
        }
        this.chartData.labels.push(date)
        this.chartData.amount.push(list[i].order_amount_accepted)
        this.chartData.money.push(list[i].order_money_accepted)
      }

      this.$nextTick(() => {
        const type = ['amount', 'money']
        type.forEach(item => {
          // clear
          if (this[`${item}Chart`] !== null) {
            this[`${item}Chart`].destroy()
          }
          // set chart
          const ctx = document.getElementById(`${item}-chart`).getContext('2d')
          const config = {
            type: 'line',
            data: {
              labels: this.chartData.labels,
              datasets: [{
                label: item === 'amount' ? '訂單數量' : '訂單金額',
                data: this.chartData[item],
                fill: false,
                borderColor: '#dd4b39',
                pointBackgroundColor: '#dd4b39',
                tension: 0.3
              }]
            },
            options: {
              responsive: true,
              legend: {
                display: false
              },
              scales: {
                yAxes: [{
                  display: true,
                  ticks: {
                    min: 0
                  }
                }]
              }
            }
          }
          this[`${item}Chart`] = new Chart(ctx, config)
        })
      })
    },
    // 下載報表
    exportFile (type) {
      this.isDownloading = true
      const query = type === 'table' ? this.setQuery('table', true) : this.setQuery(this.selectTab)
      const searchParams = new URLSearchParams(query)
      const url = '/statistic/orderSummarySheets?' + searchParams.toString()
      this.getFile('get', url, null, (response) => {
        this.isDownloading = false
        let blob = new Blob([response.data], {type: 'application/vnd.ms-excel'})
        let objectUrl = URL.createObjectURL(blob)
        let a = document.createElement('a')
        a.href = objectUrl
        a.download = `訂單列表_${moment(query.start_date).format('YYYYMMDD')}_${moment(query.end_date).format('YYYYMMDD')}.xlsx`
        document.body.appendChild(a)
        a.click()
      })
    },
    // 時間區間限制
    startDateLimit (date) {
      // max: yesterday
      return date > moment().subtract(1, 'days')
    },
    endDateLimit (date) {
      // max: (start + 30 days) or yesterday
      // min: start
      return date > moment(this.maxEndDate('chart')) || date < moment(this.dailySearch.start_date)
    },
    startMonthLimit (date) {
      // max: this month
      return date > moment()
    },
    endMonthLimit (date) {
      // max: (start + 24 months) or this month
      // min: start
      return date > moment(this.maxEndMonth) || date < moment(this.monthlySearch.start_date)
    },
    tableEndDateLimit (date) {
      // max: (start + 30 days) or yesterday
      // min: start
      return date > moment(this.maxEndDate('table')) || date < moment(this.tableSearch.start_date)
    },
    isType (type) {
      if (this.selectTab === type) return true
      else return false
    },
    clickPage (index) {
      this.paginate.tableIndex = index
      this.searchTable('changePage')
    },
    goto () {
      setSharedToken(window.localStorage.getItem(this.$config.token))
      window.location.href = `${this.$config.bdms}analytics/trend`
    }
  },
  watch: {
    'dailySearch.start_date' (val) {
      if (moment(this.dailySearch.end_date).isAfter(this.maxEndDate('chart')) || moment(this.dailySearch.end_date).isBefore(val)) {
        // 選擇日期大於最大日期 or 開始日期
        // 將選擇日期改為最大日期
        this.dailySearch.end_date = this.maxEndDate('chart')
      }
      this.endDateLimit()
    },
    'monthlySearch.start_date' (val) {
      if (moment(this.monthlySearch.end_date).isAfter(this.maxEndMonth) || moment(this.monthlySearch.end_date).isBefore(val)) {
        // 選擇日期大於最大日期 or 開始日期
        // 將選擇日期改為最大日期
        this.monthlySearch.end_date = this.maxEndMonth
      }
      this.endMonthLimit()
    },
    'tableSearch.start_date' (val) {
      if (moment(this.tableSearch.end_date).isAfter(this.maxEndDate('table')) || moment(this.tableSearch.end_date).isBefore(val)) {
        // 選擇日期大於最大日期 or 開始日期
        // 將選擇日期改為最大日期
        this.tableSearch.end_date = this.maxEndDate('table')
      }
      this.tableEndDateLimit()
    },
    selectTab (val) {
      const list = this[`${val}Search`].data
      if (Object.keys(list).length) {
        const data = val === 'daily' ? list[this.month] : list
        this.showOrderChart(data)
      } else {
        this.searchOrderSummary(true)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.download-block {
  position: absolute;
  top: 0px;
  right: 0px;
}
.z-index-1 {
  z-index: 1;
}
.canvas-block {
  width: 97%;
  margin: 30px auto;
}
.btn-search {
  border-radius: 4px !important;
  margin-left: 2px !important;
  height: 70px;
}
.m-t-2 {
  margin-top: 2px;
}
.table-hover > tbody > tr:hover {
  background-color: #FFFAE7;
}
.ein {
  padding-left: 6px;
  color: #696969;
  font-size: 10px;
  line-height: 20px;
}
.flex {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// OperatingChart.vue?ffa55612